import { Modal, ModalWidth, useGlobalModalContext } from '@creditsights/styleguide-web';
import React from 'react';
// eslint-disable-next-line import/no-named-as-default
import UpgradeSubscription, { HEADER_TEXT } from '../no-access/UpgradeSubscription';

const UpgradeSubscriptionModal = (): React.ReactElement => {
  const { closeModal } = useGlobalModalContext();

  return (
    <Modal width={ModalWidth.Medium} open onClose={closeModal} headerTitle={HEADER_TEXT}>
      <UpgradeSubscription showHeader={false} />
    </Modal>
  );
};

export default UpgradeSubscriptionModal;
